export default "__VITE_ASSET__3etMkCce__"